import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'deadlineTimePipe' })
export class DeadlineTimePipe implements PipeTransform {
  transform(minutes: number): string {
    if (minutes <= 0) {
      return '0min';
    }

    const days = Math.floor(minutes / (24 * 60));
    const remainingMinutes = minutes % (24 * 60);
    const hours = Math.floor(remainingMinutes / 60);
    const mins = remainingMinutes % 60;

    const parts = [];

    if (days > 0) {
      parts.push(`${days}d`);
    }
    if (hours > 0) {
      parts.push(`${hours}h`);
    }
    if (mins > 0) {
      parts.push(`${mins}min`);
    }

    return parts.join(' ');
  }
}
